import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { SegMenuService } from '../services/seg-menu.service';
import { SegMenuResponse } from '@/models/menu.model';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `
<ul class="layout-menu bg-white py-4 px-4">
    <ng-container
        *ngTemplateOutlet="menuTree; context: { $implicit: model, level: 0 }">
    </ng-container>
</ul>

<ng-template #menuTree let-items let-level="level">
    <ng-container *ngFor="let item of items">
        <li class="mb-1 list-none">
            <button
                *ngIf="item.items?.length"
                type="button"
                class="menu-link"
                [style.padding-left.px]="12 + (level * 14)"
                (click)="item.expanded = !item.expanded">
                <span>{{ item.label }}</span>
                <i class="pi text-[12px]" [ngClass]="item.expanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            </button>

            <a
                *ngIf="!item.items?.length"
                [routerLink]="item.routerLink"
                class="menu-link"
                [style.padding-left.px]="12 + (level * 14)">
                {{ item.label }}
            </a>

            <ul *ngIf="item.items?.length && item.expanded" class="m-0 p-0">
                <ng-container
                    *ngTemplateOutlet="menuTree; context: { $implicit: item.items, level: level + 1 }">
                </ng-container>
            </ul>
        </li>
    </ng-container>
</ng-template>
`,
    styles: [
        `
        .menu-link {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-right: 12px;
            border-radius: 8px;
            color: #0f172a !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            line-height: 20px;
            text-align: left;
            background: transparent;
        }

        .menu-link:hover {
            background: #F2F3F6;
        }

        .layout-menu,
        .layout-menu ul {
            list-style: none;
            margin: 0;
        }
    `
    ]

})
export class AppMenu implements OnInit {
    private segMenu = inject(SegMenuService);

    model: any[] = [];

    ngOnInit(): void {
        this.segMenu.getMenus().subscribe({
            next: (data) => {

                const mapped = this.mapApiToSidebarItems(data);

                const fixedStart = [{ label: 'Início', routerLink: ['/pagina-comprador'] }];

                this.model = [...fixedStart, ...mapped];
            },
            error: (err) => {
                console.error('[APP-MENU MOBILE] erro:', err);

                this.model = [{ label: 'Início', routerLink: ['/pagina-comprador'] }];
            }
        });
    }

    private mapApiToSidebarItems(arr: SegMenuResponse[]): any[] {
        if (!Array.isArray(arr)) return [];
        const sorted = [...arr].sort((a, b) => (a.ordem ?? Number.MAX_SAFE_INTEGER) - (b.ordem ?? Number.MAX_SAFE_INTEGER));
        return sorted
            .map((m) => this.mapApiItem(m))
            .filter(Boolean) as any[];
    }

    private mapApiItem(m: SegMenuResponse): any | null {
        const label = m.nome?.trim() || '';
        if (!label) return null;

        const filhosVisiveis = Array.isArray(m.filhos) && m.filhos.length
            ? this.mapApiToSidebarItems(m.filhos)
            : [];

        const temFilhosVisiveis = filhosVisiveis.length > 0;
        const temUrl = !!m.url?.trim();

        // Igual ao menu grande: não mostra item sem rota e sem filhos
        if (!temUrl && !temFilhosVisiveis) {
            return null;
        }

        const routerLink = temUrl
            ? [(m.url!.startsWith('/') ? m.url! : '/' + m.url!)]
            : undefined;

        return {
            label,
            routerLink: temFilhosVisiveis ? undefined : routerLink,
            items: temFilhosVisiveis ? filhosVisiveis : undefined,
            expanded: false
        };
    }

}
